export const content_ids = {
  default: {
    'en': {
      'top': process.env.EN_ID,
      'bottom': process.env.EN_BELOW_ID
    },
    'en-apac': process.env.EN_ID,
    'en-eu': process.env.EN_ID,
    'en-mea': process.env.EN_ID,
    'en-in': process.env.EN_ID,
    'es': process.env.ES_ID,
    'pt-br': process.env.BR_ID,
    'nl': process.env.NL_ID
  },
  sem: {
    'en': process.env.SEM_ID
  },
  he: {
    'en': {
      'top': process.env.EN_HE_ID,
      'bottom': process.env.EN_HE_BELOW_ID
    },
    'en-apac': process.env.EN_APAC_HE_ID,
    'en-eu':  process.env.EN_EU_HE_ID,
    'en-mea': process.env.EN_EU_HE_ID,
    'en-in': process.env.EN_EU_HE_ID,
    'es': process.env.ES_HE_ID,
    'pt-br': process.env.BR_HE_ID,
    'nl': process.env.NL_HE_ID
  },
  mru: {
    'en': {
      'top': process.env.EN_SANDBOX_ID,
      'bottom': process.env.EN_SANDBOX_BELOW_ID
    },
  },
  bc: {
    'en': {
      'top': process.env.EN_BC_ID,
      'bottom': process.env.EN_BC_BELOW_ID
    },
  },
  bill: {
    'en': {
      'top': process.env.EN_SANDBOX_ID,
      'bottom': process.env.EN_SANDBOX_BELOW_ID
    },
  },
  suny: {
    'en': {
      'top': process.env.EN_SUNY_ID,
      'bottom': process.env.EN_SUNY_BELOW_ID
    },
  },
  'k-12': {
    'en': {
      'top': process.env.EN_K12_ID,
      'bottom': process.env.EN_K12_BELOW_ID
    },
    'en-apac': process.env.EN_APAC_K12_ID,
    'en-eu': process.env.EN_K12_ID,
    'en-mea': process.env.EN_K12_ID,
    'es': process.env.ES_K12_ID,
    'pt-br': process.env.BR_K12_ID,
    'nl': process.env.NL_K12_ID
  },
  corp: {
    'en': {
      'top': process.env.EN_CORP_ID,
      'bottom': process.env.EN_CORP_BELOW_ID
    },
    'en-apac': process.env.EN_APAC_CORP_ID,
    'en-eu': process.env.EN_EU_CORP_ID,
    'en-mea': process.env.EN_MEA_CORP_ID,
    'es': process.env.ES_CORP_ID,
    'pt-br': process.env.BR_CORP_ID
  },
  legal: {
    'en': process.env.EN_LEGAL_ID,
    'en-apac': process.env.EN_LEGAL_ID,
    'en-eu': process.env.EN_LEGAL_ID,
    'en-mea': process.env.EN_LEGAL_ID,
    'en-in': process.env.EN_LEGAL_ID,
    'es': process.env.ES_LEGAL_ID,
    'pt-br': process.env.BR_LEGAL_ID
  },
  curriculum: {
    'en': process.env.BAYFIELD_ID
  },
  'digital-resources': {
    'en': process.env.BAYFIELD_ID
  },
  'd2l-adventure': {
    'en': process.env.BAYFIELD_ID
  },
  'adventure': {
    'en': process.env.BAYFIELD_ID
  },
}



// WEBPACK FOOTER //
// ./src/components/data/contentIds.js